export default __webpack_public_path__ + "75a89700c6a21ad86d64c919b57213b8.svg";